import axios from "axios"
import React, { Suspense, useEffect, useState } from "react"
import { Helmet } from "react-helmet"
import Layout from "../components/Layout"
import Particle from "../components/Particle"
import Socialicons from "../components/Socialicons"
import Spinner from "../components/Spinner"

interface Information {
  name: string
  aboutContent: string
}

interface HomeProps {
  lightMode: boolean
}

const Home: React.FC<HomeProps> = ({ lightMode }) => {
  const [information, setInformation] = useState<Information>({ name: "", aboutContent: "" })

  useEffect(() => {
    axios.get<Information>("/api/information").then((response) => {
      setInformation(response.data)
    })
  }, [])

  return (
    <Layout>
      <Helmet>
        <title>Home - Nathan Hensher</title>
        <meta
          name="description"
          content="Nathan Hensher - Javascript Engineer - Homepage"
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-home-area mi-padding-section">
          <Particle lightMode={lightMode} />
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-12">
                <div className="mi-home-content">
                  <h1>
                    Hello, I'm{" "}
                    <span className="color-theme">{information.name}</span>
                  </h1>
                  <p>{information.aboutContent}</p>
                  <Socialicons bordered />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </Layout>
  )
}

export default Home
